//@flow
import {
  select,
  call,
  put,
  takeLatest,
  all,
  takeEvery,
} from "redux-saga/effects";
import { navigate, reset } from "../navigation/navigatorHelper";

import {
  USER_CAMPAIGN_GET_REQUESTING,
  USER_CAMPAIGN_GET_SUCCESS,
  USER_CAMPAIGN_GET_ERROR,
  USER_CAMPAIGN_GET_TEAM_SUCCESS,
  USER_CAMPAIGN_GET_TEAM_ERROR,
  USER_CAMPAIGN_GET_TEAM_REQUESTING,
  SELECT_PERFECT_STEP_ERROR,
  SELECT_PERFECT_STEP_REQUESTING,
  SELECT_PERFECT_STEP_SUCCESS,
  ACCEPT_PERFECT_STEP_ERROR,
  ACCEPT_PERFECT_STEP_REQUESTING,
  ACCEPT_PERFECT_STEP_SUCCESS,
  VALIDATE_PERFECT_STEP_REQUESTING,
  VALIDATE_PERFECT_STEP_ERROR,
  VALIDATE_PERFECT_STEP_SUCCESS,
  USER_CAMPAIGN_GET_USER_RANK_REQUESTING,
  USER_CAMPAIGN_GET_USER_RANK_SUCCESS,
  USER_CAMPAIGN_GET_USER_RANK_ERROR,
  USER_CAMPAIGN_GET_TEAM_RANK_REQUESTING,
  USER_CAMPAIGN_GET_TEAM_RANK_SUCCESS,
  USER_CAMPAIGN_GET_TEAM_RANK_ERROR,
  USER_CAMPAIGN_SET_NEXT_CATEGORY_REQUESTING,
  USER_CAMPAIGN_SET_NEXT_CATEGORY_ERROR,
  USER_CAMPAIGN_SET_NEXT_CATEGORY_SUCCESS,
  USER_CAMPAIGN_GET_ALL_SUCCESS,
  USER_CAMPAIGN_GET_ALL_ERROR,
  USER_CAMPAIGN_GET_ALL_REQUESTING,
  GET_CURRENT_USER_CAMPAIGN_REQUESTING,
  GET_CURRENT_USER_CAMPAIGN_ERROR,
  GET_CURRENT_USER_CAMPAIGN_SUCCESS,
  CAMPAIGN_JOIN_REQUESTING,
  CAMPAIGN_JOIN_SUCCESS,
  CAMPAIGN_JOIN_ERROR,
  SELECT_RECOMMENDED_STEPS_REQUESTING,
  SELECT_RECOMMENDED_STEPS_ERROR,
  SELECT_RECOMMENDED_STEPS_SUCCESS,
  GET_SPECIFIC_STEP_REQUESTING,
  GET_SPECIFIC_STEP_SUCCESS,
  GET_SPECIFIC_STEP_ERROR,
  GET_CAMPAIGN_REVIEWS_REQUESTING,
  GET_CAMPAIGN_REVIEWS_SUCCESS,
  GET_CAMPAIGN_REVIEWS_ERROR,
  SEE_COMMENTS_REVIEW_REQUESTING,
  SEE_COMMENTS_REVIEW_SUCCESS,
  SEE_COMMENTS_REVIEW_ERROR,
  COMMENT_REVIEW_SUCCESS,
  COMMENT_REVIEW_ERROR,
  UPDATE_REVIEW_SUCCESS,
  UPDATE_REVIEW_ERROR,
  COMMENT_REVIEW_REQUESTING,
  UPDATE_REVIEW_REQUESTING,
  CANCEL_SELECTED_STEP_REQUESTING,
  CANCEL_SELECTED_STEP_SUCCESS,
  CANCEL_SELECTED_STEP_ERROR,
  ADD_STEP_COMMENT_REQUESTING,
  ADD_STEP_COMMENT_SUCCESS,
  ADD_STEP_COMMENT_ERROR,
  REMOVE_COMMENT_SUCCESS,
  REMOVE_COMMENT_ERROR,
  REMOVE_COMMENT_REQUESTING,
  GET_STEP_COMMENT_ERROR,
  GET_STEP_COMMENT_SUCCESS,
  GET_STEP_COMMENT_REQUESTING,
  GET_STEP_COMMENT_INFO_ERROR,
  GET_STEP_COMMENT_INFO_SUCCESS,
  GET_STEP_COMMENT_INFO_REQUESTING,
  GET_ALL_RESPONSES_SUCCESS,
  GET_ALL_RESPONSES_ERROR,
  GET_ALL_RESPONSES_REQUESTING,
  ADD_LIKE_STEP_COMMENT_SUCCESS,
  ADD_LIKE_STEP_COMMENT_ERROR,
  ADD_LIKE_STEP_COMMENT_REQUESTING,
  REMOVE_LIKE_STEP_COMMENT_REQUESTING,
  REMOVE_LIKE_STEP_COMMENT_SUCCESS,
  REMOVE_LIKE_STEP_COMMENT_ERROR,
  SEND_RESPONSE_REQUESTING,
  SEND_RESPONSE_ERROR,
  UPDATE_COMMENT_REQUESTING,
  UPDATE_COMMENT_SUCCESS,
  UPDATE_COMMENT_ERROR,
  SELECT_STEP,
  GET_EVENTS_SUCCESS,
  GET_EVENTS_ERROR,
  GET_EVENTS_REQUESTING,
  SELECT_FEEDBACK_ID,
  SELECT_FEEDBACK_FROM_STEP_ID,
} from "./constants";

import ObjectID from "bson-objectid";
import { fetchApi } from "../api";
import {
  changeActionState,
  changeComment,
  changeDonePercentage,
  changeRating,
  resetActionFeedbackSharedState,
} from "../action/actions";
import {
  AlertType,
  changeUserInfo,
  showAlert,
} from "../profileSettings/actions";
import i18n from "../../i18n";
import {
  getTeamRequest,
  getCurrentUserCampaignRequest,
  addStepCommentRequest,
  getStepCommentInfoByStepId,
  getEventsRequest,
} from "./actions";
import {
  getUserExperience,
  getUserId,
  getClientId,
  getChallengeReminderTime,
  getUserFirstName,
  getUserPicture,
} from "@microdoing/shared/services/user/selectors";
import {
  getCampaignId,
  getReviewSelectedCorrectorId,
  getActiveStepId,
  getStepFeedbackSelectedId,
  getUserCampaignId,
  getActiveStep,
  getStepFeedbacks,
} from "./selectors";
import {
  cancelAllNotifications,
  cancelChallengeReminderNotif,
  scheduleChallengeNotif,
  scheduleGoalNotif,
} from "@microdoing/shared/services/notifService";
import { getCampaignResourcesRequest } from "@microdoing/shared/services/resources/actions";
import { uploadFileFlow } from "../upload/sagas";
import { getFilesToUpload } from "../upload/selectors";
import createUploadUrlName from "../../utils/createUploadUrlName";
import { modifyUser, updateUserWithoutResponseRequest } from "../user/actions";
import removeHtmlTags from "../../utils/removeHtmlTags";
import selectLanguage from "../../utils/selectLanguage";
import { getLanguage } from "../profileSettings/selectors";
import hasNotificationPermission from "@microdoing/shared/utils/hasNotificationPermission";
import { updateFilesToUpload } from "../upload/actions";
import hasImageExtension from "../../utils/hasImageExtension";
import hasVideoExtension from "../../utils/hasVideoExtension";
import hasAudioExtension from "../../utils/hasAudioExtension";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import { getIsFeedbackSharedState } from "@microdoing/shared/services/action/selectors";
import { SELECT_FEEDBACK } from "../historical/constants";

/**
 * Necessary to make develop works - import is undefined otherwise - weird bug
 */
console.log(getIsFeedbackSharedState);
console.log(cancelAllNotifications);
console.log(cancelChallengeReminderNotif);

const endPoints = {
  getAllUserCampaignByUserId: "/v1/usercampaigns/user/", // :userId
  getSpecificStep: "/v1/steps/get-quickly/", // :stepId
  getUserCampaign: "/v1/usercampaigns/", // :userCampaignId
  getCurrentUserCampaign: "/v1/usercampaigns/current/", // :userId
  getTeamByCampaignId: "/v1/teams/campaign", // userId/campaignId
  selectPerfectStep: "/v1/usercampaigns/perfect-step/select",
  selectRecommendedSteps: "/v1/usercampaigns/recommended-steps/select",
  acceptPerfectStep: "/v1/usercampaigns/perfect-step/accept",
  validatePerfectStep: "/v1/usercampaigns/perfect-step/validate",
  cancelSelectedStep: "/v1/usercampaigns/perfect-step/cancel",
  setNextCategory: "/v1/usercampaigns/next-category",
  getUserRank: "/v1/campaigns/rank/user", // :userId campaignId, ? &
  getTeamRank: "/v1/campaigns/rank/team", //  userId: String, campaignId: String
  joinCampaign: "/v1/campaigns/participants/add",
  getEvents: "/v1/events", // :campaignId
  getReviews: "/v1/step-feedbacks/reviews/campaign", // userId: String, campaignId: String
  commentReview: "/v1/step-feedbacks/reviews/comment", // userId: String, campaignId: String
  seeCommentsReview: "/v1/step-feedbacks/reviews/comments/see", // userId: String, campaignId: String
  updateReviewByUser: "/v1/step-feedbacks/reviews/update-by-user", // userId: String, campaignId: String,
  addStepComment: "/v1/step-comments/add",
  removeStepComment: "/v1/step-comments/remove-comment",
  updateStepComment: "/v1/step-comments/modify-comment",
  getStepCommentsByStepId: "/v1/step-comments/get-all-step-comments-by-step-id",
  getStepCommentInfoByStepId:
    "/v1/step-comments/get-step-comments-info-by-step-id",
  getAllResponsesByStepCommentId:
    "/v1/step-comments/get-all-responses-by-step-comment-id",
  addLikeToCommentary: "/v1/step-comments/add-like",
  removeLikeFromCommentary: "/v1/step-comments/remove-like",
  sendResponseByStepCommentId: "/v1/step-comments/answer-comment",
  removeResponseToStepComment: "/v1/step-comments/remove-comment",
};

const removeStepCommentApi = data => {
  const { stepCommentId } = data;

  return fetchApi(
    `${endPoints.removeStepComment}/${stepCommentId}`,
    {},
    "patch",
  );
};

const updateStepCommentApi = data => {
  const { stepCommentId, comment } = data;

  return fetchApi(
    `${endPoints.updateStepComment}/${stepCommentId}`,
    { comment },
    "patch",
  );
};

const addStepCommentApi = data => {
  const { userId, stepId, comment, fileId, campaignId } = data;

  return fetchApi(
    `${endPoints.addStepComment}/${stepId}`,
    { userId, comment, fileId, campaignId },
    "post",
  );
};

const addLikeToCommentaryApi = data => {
  const { stepCommentId, userId } = data;

  return fetchApi(
    `${endPoints.addLikeToCommentary}/${stepCommentId}`,
    { userId },
    "post",
  );
};

const removeLikeFromCommentaryApi = data => {
  const { stepCommentId, userId } = data;

  return fetchApi(
    `${endPoints.removeLikeFromCommentary}/${stepCommentId}`,
    { userId },
    "patch",
  );
};

const getStepCommentsByStepIdApi = data => {
  const { stepId } = data;

  return fetchApi(`${endPoints.getStepCommentsByStepId}/${stepId}`, "get");
};

const getStepCommentInfoByStepIdApi = data => {
  const { stepId } = data;

  return fetchApi(`${endPoints.getStepCommentInfoByStepId}/${stepId}`, "get");
};

const getAllResponsesByStepCommentId = data => {
  const { stepCommentId } = data;

  return fetchApi(
    `${endPoints.getAllResponsesByStepCommentId}/${stepCommentId}`,
    "get",
  );
};

const sendResponseToStepCommentApi = data => {
  const { stepCommentId } = data;

  return fetchApi(
    `${endPoints.sendResponseByStepCommentId}/${stepCommentId}`,
    data,
    "post",
  );
};

const setNextCategoryApi = data => {
  return fetchApi(endPoints.setNextCategory, data, "patch");
};

const cancelSelectedStepApi = data => {
  return fetchApi(endPoints.cancelSelectedStep, data, "post");
};

const getAllUserCampaignApi = data => {
  return fetchApi(endPoints.getAllUserCampaignByUserId + data, {}, "get");
};

const getCurrentUserCampaignApi = data => {
  const { userId } = data;
  return fetchApi(`${endPoints.getCurrentUserCampaign}${userId}`, {}, "get");
};

const getUserCampaignApi = data => {
  return fetchApi(endPoints.getUserCampaign + data, {}, "get");
};

const selectPerfectStepApi = data => {
  return fetchApi(endPoints.selectPerfectStep, data, "post");
};

const selectRecommendedStepsApi = data => {
  return fetchApi(endPoints.selectRecommendedSteps, data, "post");
};

const acceptPerfectStepApi = data => {
  return fetchApi(endPoints.acceptPerfectStep, data, "post");
};

const validatePerfectStepApi = data => {
  return fetchApi(endPoints.validatePerfectStep, data, "post");
};

const joinCampaignApi = data => {
  return fetchApi(endPoints.joinCampaign, data, "post");
};

const seeCommentsReviewApi = data => {
  return fetchApi(endPoints.seeCommentsReview, data, "patch");
};

const updateReviewByUserApi = data => {
  return fetchApi(endPoints.updateReviewByUser, data, "patch");
};

const commentReviewApi = data => {
  return fetchApi(endPoints.commentReview, data, "post");
};

const getSpecificStepApi = data => {
  return fetchApi(endPoints.getSpecificStep + data, {}, "get");
};

const getUserRankApi = data => {
  const { userCampaignId, campaignId } = data;
  return fetchApi(
    `${endPoints.getUserRank}?userCampaignId=${userCampaignId}&campaignId=${campaignId}`,
    {},
    "get",
  );
};

const getTeamRankApi = data => {
  const { userId, campaignId } = data;
  return fetchApi(
    `${endPoints.getTeamRank}?userId=${userId}&campaignId=${campaignId}`,
    {},
    "get",
  );
};

const getEventsApi = data => {
  const { campaignId } = data;
  return fetchApi(`${endPoints.getEvents}/${campaignId}`, {}, "get");
};

const getReviewsApi = data => {
  const { userId, campaignId } = data;
  return fetchApi(
    `${endPoints.getReviews}?userId=${userId}&campaignId=${campaignId}`,
    {},
    "get",
  );
};

const getTeamApi = data => {
  const { userId, campaignId } = data;
  return fetchApi(
    `${endPoints.getTeamByCampaignId}/${userId}/${campaignId}`,
    {},
    "get",
  );
};

function* getSpecificStepFlow(action) {
  try {
    const response = yield call(getSpecificStepApi, action.payload);
    yield put({ type: GET_SPECIFIC_STEP_SUCCESS, payload: response });
  } catch (error) {
    console.log(error);
    yield put({ type: GET_SPECIFIC_STEP_ERROR, payload: error });
  }
}

function* getCurrentUserCampaignFlow(action) {
  try {
    const response = yield call(getCurrentUserCampaignApi, action.payload);
    const { userId, campaignId } = response;

    yield put({ type: GET_CURRENT_USER_CAMPAIGN_SUCCESS, payload: response });

    const activeStepId = yield select(getActiveStepId);
    const [team, resources, step] = yield all([
      put(
        getTeamRequest({
          campaignId,
          userId,
        }),
      ),
      put(
        getEventsRequest({
          campaignId,
        }),
      ),
      put(getCampaignResourcesRequest({ campaignId, userId })),
      activeStepId && put(getStepCommentInfoByStepId({ stepId: activeStepId })),
    ]);
  } catch (error) {
    yield put({ type: GET_CURRENT_USER_CAMPAIGN_ERROR });
    console.log(error);
  }
}

function* getUserCampaignFlow(action) {
  try {
    const { userCampaignId } = action.payload;
    const response = yield call(getUserCampaignApi, userCampaignId);
    yield put({ type: USER_CAMPAIGN_GET_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: USER_CAMPAIGN_GET_ERROR });
    console.log(error);
  }
}

function* getAllUserCampaignFlow(action) {
  try {
    const { userId } = action.payload;
    const response = yield call(getAllUserCampaignApi, userId);
    yield put({ type: USER_CAMPAIGN_GET_ALL_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: USER_CAMPAIGN_GET_ALL_ERROR, payload: error });
    console.log(error);
  }
}

function* getTeamFlow(action) {
  try {
    const response = yield call(getTeamApi, action.payload);
    yield put({ type: USER_CAMPAIGN_GET_TEAM_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: USER_CAMPAIGN_GET_TEAM_ERROR, payload: error });
    console.log(error);
  }
}

function* getTeamRankFlow(action) {
  try {
    const response = yield call(getTeamRankApi, action.payload);
    yield put({ type: USER_CAMPAIGN_GET_TEAM_RANK_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: USER_CAMPAIGN_GET_TEAM_RANK_ERROR });
    console.log(error);
  }
}

function* getEventsFlow(action) {
  try {
    const response = yield call(getEventsApi, action.payload);
    yield put({ type: GET_EVENTS_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: GET_EVENTS_ERROR, payload: error });
    console.log(error);
  }
}

function* getReviewsFlow() {
  try {
    const campaignId = yield select(getCampaignId);
    const userId = yield select(getUserId);

    const response = yield call(getReviewsApi, { campaignId, userId });
    yield put({ type: GET_CAMPAIGN_REVIEWS_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: GET_CAMPAIGN_REVIEWS_ERROR, payload: error });
    console.log(error);
  }
}

function* commentReviewFlow(action) {
  try {
    const filesToUpload = yield select(getFilesToUpload);
    const userId = yield select(getUserId);
    const clientId = yield select(getClientId);
    const correctorId = yield select(getReviewSelectedCorrectorId);
    const stepFeedbackId = yield select(getStepFeedbackSelectedId);

    const fileToUpload = filesToUpload?.[0] || {};
    const { uri = "", fileType = "", type, fileName } = fileToUpload;
    const isImage = hasImageExtension(fileName);
    const isVideo = hasVideoExtension(fileName);
    const isAudio = hasAudioExtension(fileName);

    let commentObject = {
      ...action.payload.comment,
      _id: ObjectID().toHexString(),
      audio: isAudio ? uri : undefined,
      image: isImage ? uri : undefined,
      video: isVideo ? uri : undefined,
    };

    yield put(updateFilesToUpload([]));

    if (uri) {
      let fileUploadResult = { payload: { fileType: "", uri: "" } };

      const goodFileType = fileType || type || "video/mp4";

      const file = uri;
      const urlName = createUploadUrlName({ userId, fileName });

      fileUploadResult = yield uploadFileFlow({
        payload: {
          ...fileToUpload,
          file,
          modelToUpdate: "stepFeedbackComment",
          urlName,
          fileType: goodFileType,
          fileName,
          data: {
            userId,
            correctorId,
            stepFeedbackId,
            commentId: commentObject._id,
            clientId,
          },
        },
      });

      commentObject = {
        ...commentObject,
        audio: isAudio ? fileUploadResult.payload.uri : undefined,
        image: isImage ? fileUploadResult.payload.uri : undefined,
        video: isVideo ? fileUploadResult.payload.uri : undefined,
      };
    }

    const response = yield call(commentReviewApi, {
      ...action.payload,
      comment: commentObject,
    });

    yield put({ type: COMMENT_REVIEW_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: COMMENT_REVIEW_ERROR, payload: error });
    console.log(error);
  }
}

function* seeCommentsReviewFlow(action) {
  try {
    const { stepFeedbackId } = action.payload;

    const response = yield call(seeCommentsReviewApi, { stepFeedbackId });
    yield put({ type: SEE_COMMENTS_REVIEW_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: SEE_COMMENTS_REVIEW_ERROR, payload: error });
    console.log(error);
  }
}

function* updateReviewFlow(action) {
  try {
    const userId = yield select(getUserId);
    const clientId = yield select(getClientId);

    const filesToUpload = yield select(getFilesToUpload);
    const correctorId = yield select(getReviewSelectedCorrectorId);
    const stepFeedbackId = yield select(getStepFeedbackSelectedId);

    let filesNotUploaded = filesToUpload.filter(file => !file.fileUrl);
    if (filesNotUploaded.length) {
      const results = yield all(
        filesNotUploaded.map(asset => {
          const fileType = asset.fileType || asset.type || "video/mp4";
          const fileName = asset.fileName;

          const file = asset.uri;
          const urlName = createUploadUrlName({ userId, fileName });

          return uploadFileFlow({
            payload: {
              ...asset,
              file,
              modelToUpdate: "stepFeedback",
              data: {
                userId,
                correctorId,
                stepFeedbackId,
                clientId,
              },
              urlName,
              fileType,
              fileName,
            },
          });
        }),
      );
    }

    // fileToUpload have been updated
    const allFilesUploaded = yield select(getFilesToUpload);

    const response = yield call(updateReviewByUserApi, {
      ...action.payload,
      userId,
      files: allFilesUploaded.map(el => el?.passthrough || el),
    });

    yield put({ type: UPDATE_REVIEW_SUCCESS, payload: response });
    yield put(
      showAlert({
        title: i18n.t("review-updated-success-title"),
        message: i18n.t("review-updated-success-message"),
      }),
    );
  } catch (error) {
    yield put({ type: UPDATE_REVIEW_ERROR, payload: error });
    console.log(error);
  }
}

function* getUserRankFlow(action) {
  try {
    const response = yield call(getUserRankApi, action.payload);
    yield put({ type: USER_CAMPAIGN_GET_USER_RANK_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: USER_CAMPAIGN_GET_USER_RANK_ERROR });
    console.log(error);
  }
}

function* selectPerfectStepFlow(action) {
  try {
    const response = yield call(selectPerfectStepApi, action.payload);
    yield put({ type: SELECT_PERFECT_STEP_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: SELECT_PERFECT_STEP_ERROR, error });
    console.log(error);
  }
}

function* selectRecommendedStepsFlow(action) {
  try {
    const response = yield call(selectRecommendedStepsApi, action.payload);
    yield put({ type: SELECT_RECOMMENDED_STEPS_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: SELECT_RECOMMENDED_STEPS_ERROR, error });
    console.log(error);
  }
}

function* acceptPerfectStepFlow(action) {
  try {
    const response = yield call(acceptPerfectStepApi, action.payload);
    const experience = yield select(getUserExperience);
    const hasNotificationsEnabled = yield call(hasNotificationPermission);
    const userId = yield select(getUserId);
    const challengeReminderTime = yield select(getChallengeReminderTime);
    const language = yield select(getLanguage);

    yield put({ type: ACCEPT_PERFECT_STEP_SUCCESS, payload: response });
    yield put({ type: SELECT_STEP, payload: { stepSelected: response } });
    yield put({
      type: GET_STEP_COMMENT_INFO_REQUESTING,
      payload: { stepId: response.step },
    });

    if ((experience === 0 || experience === 1) && !hasNotificationsEnabled) {
      setTimeout(
        () =>
          navigate("AllowNotifications", {
            isComingFromFirstAction: true,
          }),
        2800,
      );
    }

    yield put(modifyUser({ hasChallengeReminder: true }));
    yield put(
      updateUserWithoutResponseRequest({
        userId,
        hasNotificationsEnabled,
        hasChallengeReminder: true,
      }),
    );
    if (isWebDesktop) {
      navigate("DailyFocusScreen");
    } else {
      navigate("Main");
    }

    yield put(
      showAlert({
        title: i18n.t("choose-action-success-title"),
        message: i18n.t("choose-action-success-message"),
      }),
    );

    yield cancelAllNotifications();
    yield scheduleGoalNotif();

    const title = response?.title;
    const actionTitle = selectLanguage({ text: title, language });
    const text = response?.content?.title;
    const challengeText = removeHtmlTags(
      selectLanguage({ text: text, language }),
    );
    scheduleChallengeNotif(challengeReminderTime, actionTitle, challengeText);
  } catch (error) {
    yield put({ type: ACCEPT_PERFECT_STEP_ERROR, error });
    console.log(error);
  }
}

function* validatePerfectStepFlow() {
  try {
    const userId = yield select(getUserId);
    const clientId = yield select(getClientId);
    const filesToUpload = yield select(getFilesToUpload);
    const isShared = yield select(getIsFeedbackSharedState); // is feedbackShared

    yield changeUserInfo({ hasChallengeReminder: false });
    yield cancelChallengeReminderNotif();

    let filesNotUploaded = filesToUpload.filter(file => !file.fileUrl);

    if (filesNotUploaded.length) {
      const results = yield all(
        filesNotUploaded.map(asset => {
          const fileType = asset.fileType || asset.type || "video/mp4";
          const fileName = asset.fileName;

          const file = asset.uri;
          const urlName = createUploadUrlName({ userId, fileName });

          return uploadFileFlow({
            payload: {
              ...asset,
              file,
              modelToUpdate: "stepFeedback",
              urlName,
              fileType,
              fileName,
              data: {
                clientId,
                userId,
              },
            },
          });
        }),
      );
    }

    // fileToUpload have been updated
    const allFilesUploaded = yield select(getFilesToUpload);

    const { comment, rating, donePercentage } = yield select(
      state => state.action,
    );

    const feedback = {
      rating,
      comment,
      donePercentage,
      files: allFilesUploaded.map(el => el?.passthrough || el),
    };

    const stepId = yield select(getActiveStepId);
    const userCampaignId = yield select(getUserCampaignId);
    const campaignId = yield select(getCampaignId);

    const payload = {
      stepId,
      userCampaignId,
      userId,
      feedback,
      isShared,
      campaignId,
    };

    const response = yield call(validatePerfectStepApi, payload);
    yield reset({
      index: 0,
      routes: [{ name: "Result" }],
    });
    yield put({ type: VALIDATE_PERFECT_STEP_SUCCESS, payload: response });
    yield call(addStepCommentRequest, {
      stepId,
      comment,
      fileId: "",
      campaignId,
    });
    yield put(
      changeActionState({
        actionState: "done",
        seeActionAgain: false,
      }),
    );

    // yield put({ type: UPLOAD_RESET });
    yield put(changeUserInfo({ isReminderChecked: false }));
    yield put(updateFilesToUpload([]));
    yield put(changeRating(0));
    yield put(changeDonePercentage(0));
    yield put(resetActionFeedbackSharedState());
    yield put(changeComment(""));
  } catch (error) {
    console.log(error);
    yield put({ type: VALIDATE_PERFECT_STEP_ERROR, payload: error?.message });
  }
}

function* setNextCategoryFlow(action) {
  try {
    const response = yield call(setNextCategoryApi, action.payload);
    yield put({
      type: USER_CAMPAIGN_SET_NEXT_CATEGORY_SUCCESS,
      payload: response,
    });
    yield put(
      showAlert({
        title: i18n.t("next-category-selected-success-title"),
        message: i18n.t("next-category-selected-success-message"),
      }),
    );
  } catch (error) {
    yield put({ type: USER_CAMPAIGN_SET_NEXT_CATEGORY_ERROR });
    console.log(error);
  }
}

function* cancelSelectedStepFlow(action) {
  try {
    const {
      hasRequestedForUnblock = false,
      reason = "",
      comment = "",
      isDoItLaterOptionChecked = false,
    } = action.payload;
    const userCampaignId = yield select(getUserCampaignId);

    if (!hasRequestedForUnblock) {
      yield navigate("SelectAction");
    }

    const response = yield call(cancelSelectedStepApi, {
      userCampaignId,
      hasRequestedForUnblock,
      reason,
      comment,
      isDoItLaterOptionChecked,
    });

    yield put({
      type: CANCEL_SELECTED_STEP_SUCCESS,
      payload: response,
    });

    if (hasRequestedForUnblock) {
      if (isWebDesktop) {
        return yield reset({ index: 0, routes: [{ name: "SelectAction" }] });
      }
      yield reset({
        index: 1,
        routes: [{ name: "Main" }, { name: "SelectAction" }],
      });
    }
  } catch (error) {
    console.log(error);
    yield put({ type: CANCEL_SELECTED_STEP_ERROR, payload: error });
  }
}

function* joinCampaignFlow(action) {
  try {
    const { userId } = action.payload;
    const response = yield call(joinCampaignApi, action.payload);
    yield put({
      type: CAMPAIGN_JOIN_SUCCESS,
      payload: response,
    });
    yield put(
      showAlert({
        title: i18n.t("join-campaign-success-title"),
        message: i18n.t("join-campaign-success-message"),
      }),
    );
    yield put(getCurrentUserCampaignRequest({ userId }));
  } catch (error) {
    yield put({ type: CAMPAIGN_JOIN_ERROR, payload: error.message });
    yield put(
      showAlert({
        alertType: AlertType.ERROR,
        title: i18n.t(error.message),
        message: i18n.t(error.message),
      }),
    );
    console.log(error);
  }
}

function* getStepCommentsRequestByStepIdFlow(action) {
  try {
    const { stepId } = action.payload;

    const response = yield call(getStepCommentsByStepIdApi, { stepId });

    yield put({ type: GET_STEP_COMMENT_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: GET_STEP_COMMENT_ERROR, payload: error?.message });
    console.log(error);
  }
}

function* getAllResponsesByStepCommentIdFlow(action) {
  try {
    const { stepCommentId } = action.payload;

    const response = yield call(getAllResponsesByStepCommentId, {
      stepCommentId,
    });

    yield put({
      type: GET_ALL_RESPONSES_SUCCESS,
      payload: { responses: response, stepCommentId },
    });
  } catch (error) {
    yield put({ type: GET_ALL_RESPONSES_ERROR, payload: error?.message });
    console.log(error);
  }
}

function* sendResponseToStepCommentFlow(action) {
  try {
    const {
      stepCommentId,
      comment,
      stepId,
      receiverId,
      campaignId,
    } = action.payload;

    const userId = yield select(getUserId);
    const firstName = yield select(getUserFirstName);
    const picture = yield select(getUserPicture);

    // !! Handle by real time
    yield call(sendResponseToStepCommentApi, {
      stepId,
      receiverId,
      stepCommentId,
      userId,
      comment,
      firstName,
      picture,
      campaignId,
    });
  } catch (error) {
    yield put({ type: SEND_RESPONSE_ERROR, payload: error?.message });
    console.log(error);
  }
}

function* removeStepCommentRequestFlow(action) {
  try {
    const { stepCommentId } = action.payload;

    const res = yield call(removeStepCommentApi, {
      stepCommentId,
    });

    yield put({
      type: REMOVE_COMMENT_SUCCESS,
      payload: { stepCommentId },
    });

    yield put(
      showAlert({
        title: i18n.t("remove-comment-success-title"),
        message: i18n.t("remove-comment-success-message"),
      }),
    );
  } catch (error) {
    yield put({ type: REMOVE_COMMENT_ERROR, payload: error?.message });
    console.log(error);
  }
}

function* getStepCommentInfoRequestByStepIdFlow(action) {
  try {
    const { stepId } = action.payload;

    const response = yield call(getStepCommentInfoByStepIdApi, { stepId });

    yield put({
      type: GET_STEP_COMMENT_INFO_SUCCESS,
      payload: { ...response, stepId },
    });
  } catch (error) {
    yield put({ type: GET_STEP_COMMENT_INFO_ERROR, payload: error?.message });
    console.log(error);
  }
}

function* addLikeToCommentaryFlow(action) {
  try {
    const { stepCommentId } = action.payload;
    const userId = yield select(getUserId);

    yield call(addLikeToCommentaryApi, {
      stepCommentId,
      userId,
    });

    yield put({
      type: ADD_LIKE_STEP_COMMENT_SUCCESS,
      payload: { userId, stepCommentId },
    });
  } catch (error) {
    yield put({ type: ADD_LIKE_STEP_COMMENT_ERROR, payload: error?.message });
    console.log(error);
  }
}

function* removeLikeFromCommentaryFlow(action) {
  try {
    const { stepCommentId } = action.payload;
    const userId = yield select(getUserId);

    yield call(removeLikeFromCommentaryApi, {
      stepCommentId,
      userId,
    });

    yield put({
      type: REMOVE_LIKE_STEP_COMMENT_SUCCESS,
      payload: { userId, stepCommentId },
    });
  } catch (error) {
    yield put({
      type: REMOVE_LIKE_STEP_COMMENT_ERROR,
      payload: error?.message,
    });
    console.log(error);
  }
}

function* addStepCommentRequestFlow(action) {
  try {
    const { comment, stepId, fileId, campaignId } = action.payload;
    const userId = yield select(getUserId);

    const response = yield call(addStepCommentApi, {
      stepId,
      comment,
      fileId,
      campaignId,
      userId,
    });

    yield put({
      type: ADD_STEP_COMMENT_SUCCESS,
      payload: response,
    });

    yield put(
      showAlert({
        title: i18n.t("add-comment-success-title"),
        message: i18n.t("add-comment-success-message"),
      }),
    );
  } catch (error) {
    yield put({ type: ADD_STEP_COMMENT_ERROR, payload: error?.message });
    console.log(error);
  }
}

function* updateStepCommentRequestFlow(action) {
  try {
    const { comment, stepCommentId } = action.payload;
    yield call(updateStepCommentApi, {
      stepCommentId,
      comment,
    });

    yield put({
      type: UPDATE_COMMENT_SUCCESS,
      payload: { stepCommentId, commentUpdated: comment },
    });

    yield put(
      showAlert({
        title: i18n.t("add-comment-success-title"),
        message: i18n.t("add-comment-success-message"),
      }),
    );
  } catch (error) {
    yield put({ type: UPDATE_COMMENT_ERROR, payload: error?.message });
    console.log(error);
  }
}

function* selectReviewFromFeedbackIdFlow(action) {
  try {
    const stepFeedbackId = action.payload;

    const feedbacks = yield select(getStepFeedbacks);

    const goodFeedback = feedbacks.find(
      feedback => feedback._id === stepFeedbackId,
    );
    const goodStepId = goodFeedback.stepId._id;

    yield put({ type: GET_SPECIFIC_STEP_REQUESTING, payload: goodStepId });
    yield put({ type: SELECT_FEEDBACK, payload: goodFeedback._id });
  } catch (error) {
    console.log(error);
  }
}

function* selectReviewFromStepIdFlow(action) {
  try {
    const stepId = action.payload;

    const feedbacks = yield select(getStepFeedbacks);

    const goodFeedback = feedbacks.find(
      feedback => feedback.stepId._id === stepId,
    );
    const goodStepId = goodFeedback.stepId._id;

    yield put({ type: GET_SPECIFIC_STEP_REQUESTING, payload: goodStepId });
    yield put({ type: SELECT_FEEDBACK, payload: goodFeedback._id });
  } catch (error) {
    console.log(error);
  }
}

function* userCampaignWatcher() {
  yield all([
    takeLatest(USER_CAMPAIGN_GET_REQUESTING, getUserCampaignFlow),
    takeLatest(USER_CAMPAIGN_GET_ALL_REQUESTING, getAllUserCampaignFlow),
    takeLatest(USER_CAMPAIGN_GET_TEAM_REQUESTING, getTeamFlow),
    takeLatest(SELECT_PERFECT_STEP_REQUESTING, selectPerfectStepFlow),
    takeLatest(SELECT_RECOMMENDED_STEPS_REQUESTING, selectRecommendedStepsFlow),
    takeLatest(ACCEPT_PERFECT_STEP_REQUESTING, acceptPerfectStepFlow),
    takeLatest(VALIDATE_PERFECT_STEP_REQUESTING, validatePerfectStepFlow),
    takeLatest(USER_CAMPAIGN_GET_TEAM_RANK_REQUESTING, getTeamRankFlow),
    takeLatest(USER_CAMPAIGN_GET_USER_RANK_REQUESTING, getUserRankFlow),
    takeLatest(GET_SPECIFIC_STEP_REQUESTING, getSpecificStepFlow),
    takeLatest(USER_CAMPAIGN_SET_NEXT_CATEGORY_REQUESTING, setNextCategoryFlow),
    takeLatest(
      GET_CURRENT_USER_CAMPAIGN_REQUESTING,
      getCurrentUserCampaignFlow,
    ),
    takeLatest(CAMPAIGN_JOIN_REQUESTING, joinCampaignFlow),
    takeLatest(GET_CAMPAIGN_REVIEWS_REQUESTING, getReviewsFlow),
    takeLatest(SEE_COMMENTS_REVIEW_REQUESTING, seeCommentsReviewFlow),
    takeEvery(COMMENT_REVIEW_REQUESTING, commentReviewFlow),
    takeLatest(UPDATE_REVIEW_REQUESTING, updateReviewFlow),
    takeLatest(CANCEL_SELECTED_STEP_REQUESTING, cancelSelectedStepFlow),
    takeLatest(ADD_STEP_COMMENT_REQUESTING, addStepCommentRequestFlow),
    takeLatest(REMOVE_COMMENT_REQUESTING, removeStepCommentRequestFlow),
    takeLatest(UPDATE_COMMENT_REQUESTING, updateStepCommentRequestFlow),
    takeLatest(GET_STEP_COMMENT_REQUESTING, getStepCommentsRequestByStepIdFlow),
    takeLatest(
      GET_STEP_COMMENT_INFO_REQUESTING,
      getStepCommentInfoRequestByStepIdFlow,
    ),
    takeLatest(
      GET_ALL_RESPONSES_REQUESTING,
      getAllResponsesByStepCommentIdFlow,
    ),
    takeLatest(ADD_LIKE_STEP_COMMENT_REQUESTING, addLikeToCommentaryFlow),
    takeLatest(
      REMOVE_LIKE_STEP_COMMENT_REQUESTING,
      removeLikeFromCommentaryFlow,
    ),
    takeLatest(SEND_RESPONSE_REQUESTING, sendResponseToStepCommentFlow),
    takeLatest(GET_EVENTS_REQUESTING, getEventsFlow),
    takeLatest(SELECT_FEEDBACK_ID, selectReviewFromFeedbackIdFlow),
    takeLatest(SELECT_FEEDBACK_FROM_STEP_ID, selectReviewFromStepIdFlow),
  ]);
}

export default userCampaignWatcher;
